module.exports = __webpack_public_path__ + "img/avt.2820b9a8.png";